import { useSearchResults } from '#src/app/pages/searchV2/shared/searchState';

type Result = ModelHookResult<{
	isLoading: boolean;
	isError: boolean;
	isEmptyResults: boolean;
}>;

export function useSearchResultList(): Result {
	const results = useSearchResults();

	return {
		data: {
			isLoading: results.isLoading || results.isInitialLoad,
			isError: results.isError,
			isEmptyResults: !results.isInitialLoad && !results.isLoading && results.nbHits === 0,
		},
	};
}
